var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { createContext, useCallback, useEffect, useMemo, useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PlanTypeCategory } from '../../enum';
import { useTerminologyTranslation } from '../app/terminology';
import { FormlessProvider } from '../hooks/useFormlessContext';
import { WizardStep } from './constants';
import { useCompletedStep, useQueueAPI, useQueuesAPI, useRefreshQueueData, useSaveQueueAPI } from './queue/selectors';
import { useIsPlanLocked, usePlanTypeCategory, useWizardParams } from './selectors';
import { useDefaultValues } from './useDefaultValue';
import { useValidateForm } from './validateForm';
var isMissingLearningCurve = function (value) {
  return value == null || value === '';
};
var withDefaultLearningCurve = function (formData) {
  var _a, _b;
  return __assign(__assign({}, formData), {
    volumes: (_a = formData.volumes) === null || _a === void 0 ? void 0 : _a.map(function (volume) {
      return __assign(__assign({}, volume), {
        learnCurve: isMissingLearningCurve(volume.learnCurve) ? 100 : volume.learnCurve
      });
    }),
    queueLocations: (_b = formData.queueLocations) === null || _b === void 0 ? void 0 : _b.map(function (queueLocation) {
      var _a;
      return __assign(__assign({}, queueLocation), {
        volumes: (_a = queueLocation.volumes) === null || _a === void 0 ? void 0 : _a.map(function (volume) {
          return __assign(__assign({}, volume), {
            learnCurve: isMissingLearningCurve(volume.learnCurve) ? 100 : volume.learnCurve
          });
        })
      });
    })
  });
};
var isMissingPartTime = function (value) {
  return value == null || value === '';
};
var withDefaultExistingPartTime = function (values) {
  var next = __assign({}, values);
  var partTimeFields = ['totalPartTime', 'hoursPerDay', 'daysPerWeek'];
  var existingPartTimeFields = partTimeFields.filter(function (field) {
    return field in next;
  });
  var shouldZeroPartTime = existingPartTimeFields.some(function (field) {
    return isMissingPartTime(next[field]) || Number(next[field]) === 0;
  });
  if (shouldZeroPartTime) {
    existingPartTimeFields.forEach(function (field) {
      next[field] = 0;
    });
  }
  return next;
};
var withDefaultPartTime = function (formData) {
  var _a;
  return __assign(__assign({}, withDefaultExistingPartTime(formData)), {
    queueLocations: (_a = formData.queueLocations) === null || _a === void 0 ? void 0 : _a.map(function (queueLocation) {
      return __assign({}, withDefaultExistingPartTime(queueLocation));
    })
  });
};
var withDefaultShrinkagePercent = function (formData) {
  var next = __assign({}, formData);
  if (next.shrinkages) {
    next.shrinkages = next.shrinkages.map(function (group) {
      return (group || []).map(function (shrinkage) {
        return __assign(__assign({}, shrinkage), {
          percent: shrinkage.percent === '' || shrinkage.percent == null ? 0 : shrinkage.percent
        });
      });
    });
  }
  return next;
};
var withDefaultFinancial = function (formData) {
  var next = __assign({}, formData);
  if (next.multiplier === '' || next.multiplier == null) {
    next.multiplier = 1;
  }
  if (next.trainWeeks === '' || next.trainWeeks == null) {
    next.trainWeeks = 0;
  }
  if (next.volumes) {
    next.volumes = next.volumes.map(function (volume) {
      return __assign(__assign({}, volume), {
        rate: volume.rate === '' || volume.rate == null ? 0 : volume.rate
      });
    });
  }
  if (next.queueLocations) {
    next.queueLocations = next.queueLocations.map(function (location) {
      return __assign(__assign({}, location), {
        multiplier: location.multiplier === '' || location.multiplier == null ? 1 : location.multiplier,
        trainWeeks: location.trainWeeks === '' || location.trainWeeks == null ? 0 : location.trainWeeks,
        volumes: (location.volumes || []).map(function (volume) {
          return __assign(__assign({}, volume), {
            rate: volume.rate === '' || volume.rate == null ? 0 : volume.rate
          });
        })
      });
    });
  }
  return next;
};
var withActionDefaults = function (formData, step) {
  if (step === WizardStep.HandleTime) {
    return withDefaultLearningCurve(formData);
  }
  if (step === WizardStep.WorkingDays) {
    return withDefaultPartTime(formData);
  }
  if (step === WizardStep.Shrinkage) {
    return withDefaultShrinkagePercent(formData);
  }
  if (step === WizardStep.Financial) {
    return withDefaultFinancial(formData);
  }
  return formData;
};
export var WizardContext = createContext({});
export var WizardProvider = function (props) {
  var navigate = useNavigate();
  var t = useTerminologyTranslation('wizard').t;
  var defaultValues = useDefaultValues();
  var validateForm = useValidateForm();
  var actionRef = useRef();
  var callbackRef = useRef();
  var pendingSaveRef = useRef(false);
  var methods = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(validateForm)
  });
  var reset = methods.reset,
    getValues = methods.getValues,
    handleSubmit = methods.handleSubmit,
    isDirty = methods.formState.isDirty;
  var _a = useWizardParams(),
    step = _a.step,
    queueId = _a.queueId,
    stepIndex = _a.stepIndex;
  var queueData = useQueueAPI()[0];
  var queuesData = useQueuesAPI()[0];
  var completedStep = useCompletedStep()[0];
  var _b = useSaveQueueAPI(),
    savedData = _b[0],
    fetchSave = _b[1],
    clearSavedData = _b[2];
  var requesting = !!savedData.requesting || !!queueData.requesting || !!queuesData.requesting;
  var refreshData = useRefreshQueueData();
  var planTypeCategory = usePlanTypeCategory();
  // Disable form submission if the plan is locked
  var isPlanLocked = useIsPlanLocked();
  useEffect(function () {
    reset(defaultValues);
  }, [defaultValues, reset]);
  useEffect(function () {
    if (savedData.data) {
      var siteRoleSyncNotice = savedData.data.siteRoleSyncNotice;
      var listRoles = siteRoleSyncNotice === null || siteRoleSyncNotice === void 0 ? void 0 : siteRoleSyncNotice.map(function (_a) {
        var role = _a.role;
        return role;
      }).filter(function (value, index, values) {
        return values.indexOf(value) === index;
      }).join(', ');
      if (listRoles) {
        toast.success(t('message.siteRoleRatioSyncSuccess', {
          listRoles: listRoles
        }), {
          theme: 'colored'
        });
      }
      pendingSaveRef.current = true;
      refreshData();
    }
    return clearSavedData;
  }, [clearSavedData, refreshData, savedData.data, t]);
  useEffect(function () {
    actionRef.current = undefined;
    callbackRef.current = undefined;
    pendingSaveRef.current = false;
  }, [savedData.error]);
  useEffect(function () {
    // Only call the callback after a save has completed AND the refresh has finished
    // This ensures we're checking against the latest queue data, not stale data
    // Use pendingSaveRef to track if a save was initiated, since savedData.data might be cleared
    if (queuesData.data && callbackRef.current && !queuesData.requesting && !queueData.requesting && pendingSaveRef.current) {
      pendingSaveRef.current = false;
      callbackRef.current(completedStep);
      callbackRef.current = undefined;
      actionRef.current = undefined;
    }
  }, [completedStep, queuesData.data, queuesData.requesting, queueData.requesting]);
  var buildProcessedVolumes = useCallback(function (volumes) {
    if (volumes === void 0) {
      volumes = [];
    }
    return volumes.map(function (volume, index) {
      return __assign(__assign({}, volume), {
        id: volume.id || (index + 1) * -1
      });
    });
  }, []);
  var submitForm = useCallback(function (formData, force) {
    var _a;
    if (force === void 0) {
      force = false;
    }
    // A pristine Review calculate still saves so its callback runs after refresh.
    if (!isDirty && !force || requesting || isPlanLocked) return;
    var _b = formData.shrinkages,
      shrinkages = _b === void 0 ? [] : _b,
      _c = formData.wapVolumes,
      wapVolumes = _c === void 0 ? {} : _c,
      targetOccupancy = formData.targetOccupancy,
      values = __rest(formData, ["shrinkages", "wapVolumes", "targetOccupancy"]);
    var payload = __assign(__assign({}, values), {
      volumes: buildProcessedVolumes(values.volumes),
      queueLocations: (_a = values.queueLocations) === null || _a === void 0 ? void 0 : _a.map(function (queueLocation) {
        return __assign(__assign({}, queueLocation), {
          volumes: buildProcessedVolumes(queueLocation.volumes)
        });
      }),
      shrinkages: shrinkages.flat(),
      wapVolumes: Object.values(wapVolumes).flat(2)
    });
    // For ProdHours plans, targetOccupancy is only a UI helper for the APPLY button
    // The actual occupancy per period is stored in volumes[].prodOccupancy
    // For WorkVolume plans, targetOccupancy is a valid field (when using Occupancy metric target)
    if (planTypeCategory !== PlanTypeCategory.ProdHours && targetOccupancy !== undefined) {
      payload.targetOccupancy = targetOccupancy;
    }
    fetchSave(payload);
  }, [buildProcessedVolumes, fetchSave, isDirty, planTypeCategory, requesting, isPlanLocked]);
  var handleSave = useCallback(function (action, callback) {
    if (action === void 0) {
      action = 'submit';
    }
    return function (e) {
      return __awaiter(void 0, void 0, void 0, function () {
        var values, isValid, _a, shouldSkipSubmit;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (action === 'switchQueue' && [WizardStep.HandleTime, WizardStep.Attrition, WizardStep.WorkingDays, WizardStep.Shrinkage, WizardStep.Financial].includes(step)) {
                if (!isDirty) {
                  callback === null || callback === void 0 ? void 0 : callback();
                  return [2 /*return*/];
                }
                callbackRef.current = callback;
                actionRef.current = action;
                values = getValues();
                submitForm(withActionDefaults(values, step));
                return [2 /*return*/];
              }
              if (!(action === 'calculate')) return [3 /*break*/, 1];
              _a = true;
              return [3 /*break*/, 3];
            case 1:
              return [4 /*yield*/, validateForm.isValid(getValues())];
            case 2:
              _a = _b.sent();
              _b.label = 3;
            case 3:
              isValid = _a;
              shouldSkipSubmit = !step || action !== 'calculate' && (!isDirty && action !== 'next' && action !== 'switchQueue' || !isDirty && isValid);
              if (shouldSkipSubmit) {
                callback === null || callback === void 0 ? void 0 : callback();
                if (action !== 'submit') {
                  return [2 /*return*/];
                }
              }
              callbackRef.current = callback;
              actionRef.current = action;
              // Always submit through handleSubmit so Yup runs (e.g. work arrival pattern row totals must equal 100%).
              // Partial WAP data still validates: rows with any null workVolume skip the sum check (see useWAPVolumeShape).
              handleSubmit(function (formData) {
                return submitForm(formData, action === 'calculate');
              }, function (errors) {
                console.error('Wizard validation errors:', errors);
              })(e);
              return [2 /*return*/];
          }
        });
      });
    };
  }, [getValues, handleSubmit, isDirty, step, submitForm, validateForm]);
  var handleSaveWithoutValidation = useCallback(function (action, callback) {
    if (action === void 0) {
      action = 'submit';
    }
    callbackRef.current = callback;
    actionRef.current = action;
    var values = getValues();
    submitForm(withActionDefaults(values, step));
  }, [getValues, step, submitForm]);
  var goToStep = useCallback(function (nextStep) {
    navigate("".concat(globalThis.location.pathname, "?queueId=").concat(queueId, "&step=").concat(nextStep));
    globalThis.scrollTo(0, 0);
  }, [navigate, queueId]);
  var goToQueue = useCallback(function (id) {
    navigate("".concat(globalThis.location.pathname, "?queueId=").concat(id, "&step=").concat(stepIndex));
  }, [navigate, stepIndex]);
  var value = useMemo(function () {
    return {
      handleSave: handleSave,
      actionRef: actionRef,
      requesting: requesting,
      goToStep: goToStep,
      goToQueue: goToQueue,
      methods: methods,
      handleSaveWithoutValidation: handleSaveWithoutValidation,
      saveError: savedData.error
    };
  }, [goToQueue, goToStep, handleSave, handleSaveWithoutValidation, methods, requesting, savedData.error]);
  return _jsx(WizardContext.Provider, __assign({
    value: value
  }, {
    children: _jsx(FormProvider, __assign({}, methods, {
      children: _jsx(FormlessProvider, __assign({
        control: methods.control,
        setValue: methods.setValue
      }, {
        children: props.children
      }))
    }))
  }));
};